<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم - عربي:</label>
          <div>{{ name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم - انجليزي:</label>
          <div>{{ nameEn }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحالة:</label>
          <div>{{ (isActive)? 'نشط' : 'غير نشط' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'BanksViews',
  props: {
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: '',
      nameEn: '',
      isActive: true,
    }
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.nameEn = this.dataRow.nameEn;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
